import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { PaymentService } from './service/payment.service';

export function providePayment(): EnvironmentProviders {
  return makeEnvironmentProviders([PaymentService]);
}
